var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fine-prints"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}}),(_vm.secondaryDisclaimer)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.secondaryDisclaimer)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }